<script setup>
import { ref } from 'vue';
import { rpc, sendText } from '../../../composables/useRpc.js';

const props = defineProps({
  phone: { type: String, default: '' },
  conversationId: { type: [Number, String], default: null },
});

const ancho = ref('');
const largo = ref('');
const loading = ref(false);
const sendingInfo = ref(false);
const feedback = ref('');
const feedbackType = ref(''); // 'success' | 'error'

function clearFeedback() {
  setTimeout(() => { feedback.value = ''; feedbackType.value = ''; }, 3000);
}

async function calcularYEnviar() {
  if (!Number(ancho.value) || !Number(largo.value)) return;
  loading.value = true;
  feedback.value = '';
  try {
    const result = await rpc('calculate-burbuja', {
      body: { ancho: Number(ancho.value), largo: Number(largo.value) },
    });
    if (result?.mensaje_whatsapp) {
      await sendText(props.phone, result.mensaje_whatsapp);
      feedback.value = 'Cotización enviada';
      feedbackType.value = 'success';
    } else {
      feedback.value = 'Respuesta sin mensaje';
      feedbackType.value = 'error';
    }
  } catch (e) {
    feedback.value = e.message || 'Error al calcular';
    feedbackType.value = 'error';
  } finally {
    loading.value = false;
    clearFeedback();
  }
}

async function enviarInfo() {
  sendingInfo.value = true;
  feedback.value = '';
  try {
    await rpc('wa-command', {
      body: {
        conversation_id: props.conversationId,
        command: 'sendProductMedia',
        payload: { product: 'Burbujas', trigger: 'info_request' },
      },
    });
    feedback.value = 'Info enviada';
    feedbackType.value = 'success';
  } catch (e) {
    feedback.value = e.message || 'Error al enviar info';
    feedbackType.value = 'error';
  } finally {
    sendingInfo.value = false;
    clearFeedback();
  }
}
</script>

<template>
  <div class="aj-burbuja">
    <div class="aj-burbuja-row">
      <input v-model="ancho" type="number" step="0.1" min="0" placeholder="Ancho" class="aj-burbuja-input" />
      <span class="aj-burbuja-x">x</span>
      <input v-model="largo" type="number" step="0.1" min="0" placeholder="Largo" class="aj-burbuja-input" />
      <button class="aj-burbuja-btn aj-burbuja-btn--primary" :disabled="!Number(ancho) || !Number(largo) || loading" @click="calcularYEnviar" :title="loading ? 'Calculando...' : 'Cotizar'">
        {{ loading ? '...' : 'Cotizar' }}
      </button>
      <button class="aj-burbuja-btn" :disabled="sendingInfo" @click="enviarInfo" :title="sendingInfo ? 'Enviando...' : 'Info'">
        {{ sendingInfo ? '...' : 'Info' }}
      </button>
    </div>
    <div v-if="feedback" class="aj-burbuja-feedback" :class="'aj-burbuja-feedback--' + feedbackType">{{ feedback }}</div>
  </div>
</template>

<style scoped>
.aj-burbuja {
  padding: 4px 12px;
}

.aj-burbuja-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.aj-burbuja-input {
  width: 60px;
  padding: 4px 6px;
  border: 1px solid rgb(var(--slate-5, 224 224 230));
  border-radius: 6px;
  background: rgb(var(--slate-1, 252 252 253));
  color: rgb(var(--slate-12, 28 32 36));
  font-size: 12px;
  text-align: center;
}

.aj-burbuja-input:focus {
  outline: none;
  border-color: rgb(var(--blue-8, 62 99 221));
}

.aj-burbuja-x {
  font-size: 11px;
  color: rgb(var(--slate-9));
}

.aj-burbuja-btn {
  padding: 4px 8px;
  border: 1px solid rgb(var(--slate-4));
  border-radius: 6px;
  background: rgb(var(--slate-1));
  color: rgb(var(--slate-11));
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
}

.aj-burbuja-btn:hover {
  background: rgb(var(--slate-3));
  color: rgb(var(--slate-12));
}

.aj-burbuja-btn--primary {
  background: rgb(var(--blue-9, 62 99 221));
  color: #fff;
  border-color: transparent;
}

.aj-burbuja-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.aj-burbuja-feedback {
  margin-top: 4px;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
}

.aj-burbuja-feedback--success {
  background: rgba(52, 199, 89, 0.1);
  color: rgb(var(--green-11, 34 154 64));
}

.aj-burbuja-feedback--error {
  background: rgba(229, 72, 77, 0.1);
  color: rgb(var(--red-9, 229 72 77));
}
</style>
